import {_utils} from "../../../utils/_utils.js";

/**
 * Workflow section.
 * On desktop it draws the connector lines that run from each step's dot
 * (which sits at the vertical centre of the step's bracket) to the central
 * hexagon. Because the bracket wraps the step content, the dot position is
 * dynamic, so the lines are recomputed on resize / content changes.
 */
export const workflow = () => {
    return new Promise((resolve) => {
        document.querySelectorAll('.workflow').forEach((section) => init(section));
        resolve();
    });
};

const DESKTOP = 1025;
const round = (n) => Math.round(n * 100) / 100;

const init = (section) => {
    const graphic = section.querySelector('.workflow__graphic');
    const svg = section.querySelector('.workflow__lines');
    const hex = section.querySelector('.workflow__hexagon');
    if (!graphic || !svg || !hex) return;

    const items = [...section.querySelectorAll('.workflow__item')];
    if (!items.length) return;

    const draw = () => {
        if (window.innerWidth < DESKTOP) {
            svg.innerHTML = '';
            return;
        }

        const gr = graphic.getBoundingClientRect();
        if (!gr.width || !gr.height) return;

        svg.setAttribute('viewBox', `0 0 ${round(gr.width)} ${round(gr.height)}`);

        const hr = hex.getBoundingClientRect();
        // Hexagon shoulder anchors (ratios taken from the Figma geometry).
        const anchorX = {
            left: (hr.left - gr.left) + hr.width * 0.023,
            right: (hr.left - gr.left) + hr.width * 0.977,
        };
        const anchorY = {
            top: (hr.top - gr.top) + hr.height * 0.243,
            bottom: (hr.top - gr.top) + hr.height * 0.757,
        };

        let paths = '';

        items.forEach((item) => {
            const dots = [...item.querySelectorAll('.workflow__dot')];
            const dot = dots.find((d) => d.getClientRects().length > 0);
            if (!dot) return;

            const dr = dot.getBoundingClientRect();
            const dx = (dr.left - gr.left) + dr.width / 2;
            const dy = (dr.top - gr.top) + dr.height / 2;

            const ax = item.dataset.side === 'left' ? anchorX.left : anchorX.right;
            const ay = item.dataset.vpos === 'top' ? anchorY.top : anchorY.bottom;
            const elbowX = dx + (ax - dx) * 0.48;

            paths += `<path d="M${round(dx)} ${round(dy)} L${round(elbowX)} ${round(dy)} L${round(ax)} ${round(ay)}"/>`;
        });

        svg.innerHTML = paths;
    };

    draw();
    requestAnimationFrame(draw);
    window.addEventListener('load', draw);

    if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(draw);
    }

    // Redraw on layout / content changes.
    if ('ResizeObserver' in window) {
        const ro = new ResizeObserver(() => draw());
        ro.observe(graphic);
        items.forEach((item) => ro.observe(item));
    }

    _utils.rebuildComponentsOnResize(draw);
};
